module.exports = __webpack_public_path__ + "img/yanting.71bc6dd2.png";